import React from 'react';
import { CommonIconProps } from './Icon';

const Search2 = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <g clipPath="url(#clip0_335_162)">
      <path
        d="M23.1609 20.3537L18.6191 15.8609C22.9066 9.43679 18.6319 0.780488 10.9248 0.279488C3.2176 -0.221512 -2.1417 7.80859 1.278 14.7337C2.9695 18.159 6.4593 20.3265 10.2795 20.3244C12.2646 20.3264 14.2046 19.7331 15.849 18.6212L20.4006 23.1728C21.1642 23.9318 22.3973 23.9318 23.1609 23.1728C23.9597 22.4029 23.9597 21.1237 23.1609 20.3537ZM10.2795 3.13609C15.7424 3.13629 19.1568 9.05029 16.4251 13.7812C13.6934 18.5121 6.8648 18.5118 4.1335 13.7806C3.5125 12.7048 3.1847 11.4847 3.183 10.2424C3.1829 6.32149 6.3586 3.14149 10.2795 3.13609Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_335_162">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export default Search2;
